define('pages/claim/ValueCode/ValueCodeComponent',[
	'core/can',
	'models/ValueCode',
	'template!pages/claim/ValueCode/ValueCodeView.stache',
	'jquery-inputmask',
	'typeahead'
], function (can, ValueCode, template) {

	can.view.attr()

	function makeValueCodeList(codes, fls, visible) {

		// Create List
		var listForDisplay = new ValueCode.List;
		for (var i = 0; i < fls.length; i++) {
			var code = codes.attr(i),
				exists = (code !== undefined);
			listForDisplay.push(can.extend({
				FieldLocator: fls[i],
				isHidden: !exists && (i > visible - 1)
			}, exists ? code.attr() : {}));
		}

		// Bind to Claim
		listForDisplay.bind('change', function () {
			var listForModel = [];
			this.each(function (code) {
				if (code.attr('Code') || code.attr('Amount')) {
					var o = code.attr();
					delete o.FieldLocator;
					delete o.isHidden;
					listForModel.push(o);
				}
			});
			codes.replace(listForModel);
		});

		return listForDisplay;
	}

	can.Component.extend({

		tag: 'claim-valuecodes',

		template: can.view(template),

		scope: function (attrs, scope, el) {
			return {
				isOpen: true,
				ValueCodes: makeValueCodeList(
					attrs.claim.attr('ValueCodes'),
					['39a', '40a', '41a', '39b', '40b', '41b', '39c', '40c', '41c', '39d', '40d', '41d'],
					attrs.visible
				)
			};
		},

		events: {

			'.codes-open click': function (el, ev) {
				this.scope.attr('isOpen', true);
			},

			'.codes-more click': function (el, ev) {
				this.scope.attr('ValueCodes').each(function (code) {
					code.attr('isHidden', false);
				});
			},

			'.codes-collapse click': function (el, ev) {
				var $codes = el.closest('#ValueCodes'),
					codes = this.scope.attr('ValueCodes');
				for (var i = codes.attr('length') - 1; i >= 0; --i) {
					var code = codes.attr(i);
					if (!code.attr('Code')) {
						if (i === 0) {
							this.scope.attr('isOpen', false);
						} else {
							code.attr('isHidden', true);
						}
					} else {
						break;
					}
				}
			}
		}
	});
});
